import map from 'lodash/map'
import forEach from 'lodash/forEach'
import filter from 'lodash/filter'
import toPairs from 'lodash/toPairs'

import { jsonTryParse } from '../json'

export function localFilter({ searchValue, searchFields, items }) {
  return filter(items, (item) => {
    if (!searchValue) return true

    let result = false

    forEach(searchFields, (searchField) => {
      const match = item[`${searchField.name}`] && item[`${searchField.name}`].toString().match(new RegExp(searchValue, 'i'))

      if (match) {
        result = true
      }
    })
    return result
  })
}

export function replaceYear({ replaceValues, filter }) {
  const argsReplaceDictionary = (text, name, value) => {
    text = JSON.stringify(text)
    //if the value is string, it should be wrapped by quote
    if (typeof value === 'string') {
      value = `"${value}"`
    }
    //if the value is object, convert it to json.stringify
    else if (typeof value === 'object') value = JSON.stringify(value)
    const newFilter = text?.replace(new RegExp(`"${name}"`, 'g'), value)
    return jsonTryParse(newFilter)
  }

  const dict = map(replaceValues, (item) => {
    return { ...item }
  })

  let newFilter = { ...filter }
  forEach(dict, (item) => {
    newFilter = argsReplaceDictionary(newFilter, item?.name, item?.value)
  })
  return newFilter
}

/**
 * Splits an object into two based on the presence of special keys ($or, $nor, $and).
 * @param obj The object to split.
 * @returns An object with two properties: `withOperators` and `withoutOperators`.
 */
export function splitObjectByOperators(obj: Record<string, any>): { withOperators: Record<string, any>; withoutOperators: Record<string, any> } {
  let withOperators: Record<string, any> = {}
  const withoutOperators: Record<string, any> = {}

  // Define the special operators we're interested in
  const operators = ['$or', '$nor', '$and']

  // Iterate through the object's keys
  toPairs(obj).forEach(([key, value]) => {
    // Check if the key is one of the operators or if the value itself is an object that might contain nested operators
    if (
      operators.includes(key) ||
      (typeof value === 'object' && value !== null && !Array.isArray(value) && Object.keys(value).some((subKey) => operators.includes(subKey)))
    ) {
      //const valueKey = first(Object.keys(value))
      withOperators = {
        ...withOperators,
        ...value,
      }
    } else {
      withoutOperators[key] = value
    }
  })

  return { withOperators, withoutOperators }
}
